import { BASE_PATH, BASE_PATH_EXTENSION } from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const baseUrl = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/calendar`

export async function tasksApi(controller) {
    const url = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/${controller}/tasks`;
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(url, null,config)
}

export async function getTasksApi(controller, year, month) {
    const url = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/${controller}/tasks`;
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(url, { "year": year, "month": month }, config)
}

export async function allTasksApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/all-tasks`, props, config)
}

export async function getTaskApi(id) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${baseUrl}/${id}`,config)
}

export async function updateTaskApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/update-task`, props, config)
}

export async function apiRemoveTask(id) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${baseUrl}/remove/${id}`, config)
}

export async function apiRemoveTasks(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/remove-tasks`, props, config)
}

export async function apiDuplicateTask(id) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${baseUrl}/duplicate/${id}`, config)
}

export async function apiTaskTimeExport(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/export-time`, props, config)
}

export async function getCalendarSearchAdvanced(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${baseUrl}/search-advanced`, props, config)
}

export async function checkWorkerApi(params) {
    const config = {
        headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` },
        params,
    };
    return axios.get(`${baseUrl}/check-worker`, config)
}